import { render, staticRenderFns } from "./Telbtn.vue?vue&type=template&id=674a07fd&scoped=true"
import script from "./Telbtn.vue?vue&type=script&lang=js"
export * from "./Telbtn.vue?vue&type=script&lang=js"
import style0 from "./Telbtn.vue?vue&type=style&index=0&id=674a07fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674a07fd",
  null
  
)

export default component.exports